import { Button, CircularProgress, Grid, Icon } from '@material-ui/core';
import { Field, useFormikContext } from 'formik';
import React, { useEffect } from 'react';
import { useObservable } from 'react-use-observable';
import { DateRangePickerFormField } from 'v2/components/Shared/FormFields/DateRangePicker';
import { SelectFormField } from 'v2/components/Shared/FormFields/SelectFormField';
import { TextFormField } from 'v2/components/Shared/FormFields/TextFormField';
import { useQuery } from 'v2/hooks/useQuery';
import subscriptionsService from 'v2/services/subscriptions';
import tableService from 'v2/services/table';

import AdvancedButton from '../AdvancedButton';
import { CustomerTypes, DateTypes, ECustomerSearchTypes } from '../interfaces';
import ProductFilter from '../Product';
import { useStyles } from './styles';

import type { ISubscriptionsFilter } from '../interfaces';

const BasicFilter = () => {
  const { values, isValid, isSubmitting, setFieldValue, resetForm, submitForm } = useFormikContext<ISubscriptionsFilter>();
  const classes = useStyles();
  const [isLoading] = useObservable(() => tableService.isLoading(), []);
  const [contractStatus] = useObservable(() => subscriptionsService.getStatus(), []);
  const [products] = useObservable(() => subscriptionsService.getProducts(), []);
  const [shouldResetForm] = useObservable(() => subscriptionsService.getResetForm(), []);

  const params = useQuery();

  const onChangeCustomerType = (e: React.ChangeEvent<HTMLInputElement>) => {
    const v = e.target.value;
    setFieldValue('customer', '');
    setFieldValue('customer_type', v);
  };

  const onChangeContract = (e: React.ChangeEvent<HTMLInputElement>) => {
    const v: any = e.target.value;
    let value: any = [];
    if (v && !isNaN(v)) value = v;
    setFieldValue('id', value);
  };

  useEffect(() => {
    if (shouldResetForm) {
      resetForm();
      const np = products.map((prod) => {
        prod.checked = false;
        return prod;
      });
      subscriptionsService.setProducts(np);
      subscriptionsService.setResetForm(false);
    }
  }, [products, resetForm, shouldResetForm]);

  useEffect(() => {
    const contractIds = params.get('ids');
    if (!contractIds) return;
    const isMultiple = contractIds.includes(',');
    subscriptionsService.setFilterIsAdvanced(isMultiple);
    setFieldValue('id', isMultiple ? contractIds.split(',') : contractIds);
    submitForm();
  }, [params, setFieldValue, submitForm]);

  return (
    <div>
      <Grid container spacing={1}>
        <Grid item xs={12} md={6} xl={3}>
          <Grid container>
            <Grid item xs={4} sm={6} md={4}>
              <Field
                id='date_type'
                name='date_type'
                label='Tipo de data'
                fullWidth
                inputProps={{
                  className: classes.leftInput,
                }}
                options={DateTypes}
                component={SelectFormField}
              />
            </Grid>
            <Grid item xs={8} sm={6} md={8}>
              <Field isPresetLonger label='Período' id='date' name='date' component={DateRangePickerFormField} />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={6} md={6} xl={3}>
          <Grid container>
            <Grid item xs={4}>
              <Field
                id='customer_type'
                name='customer_type'
                label='Cliente'
                inputProps={{
                  className: classes.leftInput,
                }}
                fullWidth
                options={CustomerTypes}
                component={SelectFormField}
                onChange={onChangeCustomerType}
              />
            </Grid>
            <Grid item xs={8}>
              <Field
                id='customer'
                name='customer'
                component={TextFormField}
                inputProps={{
                  className: classes.rightInput,
                }}
                fullWidth
                label={
                  values.customer_type === ECustomerSearchTypes.DOCUMENT
                    ? 'CPF/CNPJ'
                    : values.customer_type === ECustomerSearchTypes.EMAIL
                    ? 'E-mail'
                    : 'Nome'
                }
                placeholder={
                  values.customer_type === ECustomerSearchTypes.NAME
                    ? 'Insira o nome'
                    : values.customer_type === ECustomerSearchTypes.EMAIL
                    ? 'Insira o e-mail'
                    : 'Insira o CPF/CNPJ'
                }
                mask={values.customer_type === ECustomerSearchTypes.DOCUMENT ? 'document' : null}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
          <Field id='product_id' name='product_id' fullWidth hasLabel component={ProductFilter} />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={1}>
          <Field
            id='contract_id'
            name='id'
            type='tel'
            label='Contrato'
            fullWidth
            mask='number'
            component={TextFormField}
            onChange={onChangeContract}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
          <Field
            id='status'
            name='status'
            disabled={!contractStatus?.length}
            multiple
            options={contractStatus}
            fullWidth
            label='Status do contrato'
            component={SelectFormField}
          />
        </Grid>
        <Grid item xs={12} lg={3} xl={1} className={classes.buttonContainer}>
          <Button
            id='basic-filter-button'
            variant='contained'
            disabled={!isValid || isSubmitting || isLoading}
            color='secondary'
            fullWidth
            type='submit'
          >
            <Icon id='basic-filter-button-icon' style={{ marginRight: '0.5rem', fontSize: 14 }}>
              filter_list
            </Icon>{' '}
            <span id='basic-filter-button-label'>Filtrar</span>
            {(isLoading || isSubmitting) && <CircularProgress size={10} style={{ color: '#192542', marginLeft: 10 }} />}
          </Button>
        </Grid>
      </Grid>
      <AdvancedButton />
    </div>
  );
};
export default BasicFilter;
